import Experience from "../Experience";
import * as THREE from 'three';


export default class Environment {
    constructor() {
        this.experience = new Experience();
        this.scene = this.experience.scene;
        this.resources = this.experience.resources;
        this.debug = this.experience.debug;

        if(this.debug.active) {
            this.debugFolder = this.debug.ui.addFolder('Environment');
        }

        this.setSunLight();
        // this.setEnvironmentMap();
    }

    setSunLight() {
        //create ambiant light
        this.ambientLight = new THREE.AmbientLight('#ffffff', 0.3);
        this.scene.add(this.ambientLight);


        this.sunLight = new THREE.DirectionalLight('#ffffff', 1)
        this.sunLight.shadow.camera.far = 20
        this.sunLight.shadow.mapSize.set(1024, 1024)
        this.sunLight.shadow.normalBias = 0.05
        this.sunLight.position.set(5, 5, - 10)
        
        // create a helper to visualize the light
        // this.sunLightHelper = new THREE.DirectionalLightHelper(this.sunLight, 1);
        // this.scene.add(this.sunLightHelper);
        this.scene.add(this.sunLight);

        if (this.debug.active) {
            this.debugFolder
                .add(this.sunLight, 'intensity')
                .min(0)
                .max(10)
                .step(0.001)
                .name('lightIntensity');
            //add light position
            this.debugFolder
                .add(this.sunLight.position, 'x')
                .min(-5)
                .max(5)
                .step(0.001)
                .name('lightPositionX');
            this.debugFolder
                .add(this.sunLight.position, 'y')
                .min(-5)
                .max(5)
                .step(0.001)
                .name('lightPositionY');
            this.debugFolder
                .add(this.sunLight.position, 'z')
                .min(-5)
                .max(5)
                .step(0.001)
                .name('lightPositionZ');
        }
    }

    setEnvironmentMap() {
        this.environmentMap = {};
        this.environmentMap.intensity = 0.1;
        this.environmentMap.texture = this.resources.items.environmentMapTexture;
        this.environmentMap.texture.mapping = THREE.EquirectangularReflectionMapping;
        this.environmentMap.texture.encoding = THREE.sRGBEncoding;

        

        // this.scene.environment = this.environmentMap.texture;
        // this.scene.background = this.environmentMap.texture;

        this.environmentMap.updateMaterials = () => {
            this.scene.traverse((child) => {
                if (child instanceof THREE.Mesh && child.material instanceof THREE.MeshStandardMaterial) {
                    child.material.envMap = this.environmentMap.texture;
                    child.material.envMapIntensity = this.environmentMap.intensity;
                    child.material.needsUpdate = true;
                }
            });
        }
    }
}